import { InlineMessage } from '@/components/inline-message/InlineMessage'

import type { MatterAssignableRole } from './schemas'

export function InvitationRoleHint({ role }: { role: MatterAssignableRole }) {
  return (
    <div className="flex flex-col gap-2">
      <InlineMessage className="text-brand-neutral-800">
        {role === 'editor' ? (
          <>
            Editors can manage matter files and <strong className="font-bold text-brand-800">records*</strong>, view any chat, and edit any{' '}
            <strong className="font-bold text-brand-800">draft*</strong> or <strong className="font-bold text-brand-800">table*</strong> in this matter.
          </>
        ) : (
          'Contributors can manage files and view any record, chat, draft, or table in this matter.'
        )}
      </InlineMessage>
      {role === 'editor' && (
        <p className="flex items-start gap-0.5 text-xs font-normal leading-4 text-brand-neutral-600">
          <span className="shrink-0 text-brand-800">*</span>
          <span>Editor access to billing summaries, drafts, and tables coming soon.</span>
        </p>
      )}
    </div>
  )
}
